import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Palette → Coverage-tab navigation channel. A focus request may fire
 * before CoverageTab has mounted (goTab renders it in the same tick), so
 * the request is held as a pending value AND announced with a window
 * event — the tab reads the pending value on mount and subscribes for
 * later requests. The nonce makes repeat requests to the same target
 * re-trigger effects.
 */

var EVENT = 'evidence-viewer:coverage-focus';
var pending = null;
var seq = 0;
export function requestCoverageFocus(focus) {
  seq += 1;
  pending = _objectSpread(_objectSpread({}, focus), {}, {
    nonce: seq
  });
  window.dispatchEvent(new Event(EVENT));
}
export function peekCoverageFocus() {
  return pending;
}
export function onCoverageFocus(cb) {
  window.addEventListener(EVENT, cb);
  return function () {
    return window.removeEventListener(EVENT, cb);
  };
}